import React from 'react';
import { Text, TextInput, View } from 'react-native';
import { catalogProductFormStyles as styles } from './catalogProductForm.styles';
import { CatalogProductFormSegmentedRow } from './CatalogProductFormSegmentedRow';
import type { CatalogProductFormFieldsProps } from './catalogProductFormFields.types';

type Props = Pick<
  CatalogProductFormFieldsProps,
  'draft' | 'onKitchenDestinationChange' | 'onPrepMinutesChange' | 'kitchenTicketsEnabled' | 'mobile' | 'desktopRail'
>;

const KITCHEN_DESTINATION_SEGMENTS = [
  { value: 'kitchen', label: 'Cocina' },
  { value: 'bar', label: 'Barra' },
  { value: 'none', label: 'Sin ticket' },
] as const;

export function CatalogProductFormKitchenDestinationFields({
  draft,
  onKitchenDestinationChange,
  onPrepMinutesChange,
  kitchenTicketsEnabled = false,
  desktopRail = false,
}: Props) {
  if (draft.itemType !== 'physical') return null;
  if (!kitchenTicketsEnabled) return null;

  return (
    <View style={styles.ticketFormSection}>
      {!desktopRail ? <Text style={styles.ticketFormSectionTitle}>Destino de producción</Text> : null}
      <CatalogProductFormSegmentedRow
        options={KITCHEN_DESTINATION_SEGMENTS}
        value={draft.kitchenDestination}
        onChange={(id) => onKitchenDestinationChange?.(id)}
        testIDPrefix="catalog.form.kitchen-destination"
      />
      <Text style={styles.ticketFormHint}>
        Cocina: genera ticket en la cocina. Barra: genera ticket en la barra. Sin ticket: no envía a cocina (ej. bebidas que no preparás).
      </Text>
      <Text style={styles.ticketFormLabel}>Tiempo objetivo (min)</Text>
      <TextInput
        value={draft.prepMinutes}
        onChangeText={onPrepMinutesChange}
        placeholder="Usar fallback de sucursal"
        keyboardType="number-pad"
        style={styles.ticketFormInput}
        accessibilityLabel="Minutos de preparación del producto"
      />
      <Text style={styles.ticketFormHint}>Entre 5 y 240 minutos. Vacío = usa el tiempo de la sucursal.</Text>
    </View>
  );
}
